import React, { Component } from 'react';
import styled, { css } from 'styled-components';
import Title from '../shared/Title';
import { FlowHeader, HEADER_HEIGHT } from '../GoalsFlow/styles';
import { breakpoints, palette } from '../../constants/styles';

import Icon from '../shared/Icon';

const StyledResult = styled.div`
  padding: 0px 20px;

  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-top: ${HEADER_HEIGHT + 20}px;
  justify-content: flex-start;

  ${breakpoints.tablet} {
    width: 70%;
    margin-left: 15%;
    margin-right: 15%;
  }

  ${breakpoints.tabletLandscape} {
    width: 60%;
    margin-left: 20%;
    margin-right: 20%;
  }
`;

const StyledTitle = css`
  align-self: flex-start;
  margin-bottom: 1em;

  ${breakpoints.tablet} {
    align-self: center;
  }
`;

const StyledResultContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100vh;
`;

class Result extends Component {
  state = {};

  render() {
    return (
      <StyledResultContainer>
        <FlowHeader>
          <Title level={5} color="white" styles={css`margin-bottom: 0px;`} medium>¡Gracias!</Title>
        </FlowHeader>
        <StyledResult>
          <Title level={3} styles={StyledTitle} medium>
            Recibirás una llamada
            {' '}
            {this.props.when}
          </Title>
          <Icon icon="successIconRound" color={palette.secondaryColor} size={120} />
        </StyledResult>
      </StyledResultContainer>
    );
  }
}

export default Result;
